export class RadioOption {

  value: string;

  isMatch: boolean;

  constructor(value?: string) {
    this.value = value || '';
    this.isMatch = false;
  }

}
